import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';


@Injectable()
export class SessionStorageService {
  constructor(@Inject(PLATFORM_ID) private platformId: any) {
  }

  get length(): number {
    if (this.canUseSessionStorage()) {
      return sessionStorage.length;
    }
    return 0;
  }

  clear(): void {
    if (this.canUseSessionStorage()) {
      sessionStorage.clear();
    }
  }

  getItem(key: string, defaultVal: any = null): string | null {
    if (this.canUseSessionStorage()) {
      const result = sessionStorage.getItem(key);
      return result !== null ? result : defaultVal;
    }
    return defaultVal;
  }

  key(index: number): string | null {
    if (this.canUseSessionStorage()) {
      return sessionStorage.key(index);
    }
    return null;
  }

  removeItem(key: string): void {
    if (this.canUseSessionStorage()) {
      sessionStorage.removeItem(key);
    }
  }

  setItem(key: string, value: string): void {
    if (this.canUseSessionStorage()) {
      sessionStorage.setItem(key, value);
    }
  }

  private canUseSessionStorage(): boolean {
    return !!(
      isPlatformBrowser(this.platformId) &&
      window &&
      window.sessionStorage
    );
  }
}
